import { forwardRef, MouseEventHandler } from "react";
import { Box } from "@mantine/core";
import classes from "./ColorCircle.module.css";

type Props = {
  size?: number;
  onClick?: MouseEventHandler;
  color: string;
};
export const ColorCircle = forwardRef<HTMLDivElement, Props>(
  ({ size = 17, onClick, color }, ref) => (
    <Box ref={ref}>
      <Box
        onClick={onClick}
        className={classes.circle}
        style={{ backgroundColor: color, width: size, height: size }}
      ></Box>
    </Box>
  )
);

ColorCircle.displayName = "ColorCircle";
